import React from 'react';

// TOURS
import BasicTour from './Tours/BasicTour/BasicTour';

const TourGuide = () => <BasicTour />;

export default TourGuide;
